import { RoutingLinkTarget, useForm, useRedirect, useResetPassword } from '@contember/admin'
import { Button, FieldContainer, Stack, TextInput, useShowToast } from '@contember/ui'
import * as React from 'react'
import { FC, useCallback } from 'react'

interface ResetPasswordFormProps {
	token: string
	redirectOnSuccess: RoutingLinkTarget
}

const initialValues = {
	password: '',
	passwordAgain: '',
}

export const ResetPasswordForm: FC<ResetPasswordFormProps> = ({ redirectOnSuccess, token }) => {
	const redirect = useRedirect()
	const addToast = useShowToast()
	const resetPassword = useResetPassword()

	const { register, isSubmitting, onSubmit } = useForm<typeof initialValues>(initialValues, useCallback(
		async (values: typeof initialValues) => {
			if (values.password !== values.passwordAgain) {
				return addToast({ message: `Hesla nejsou stejná.`, type: 'error', dismiss: true })
			}
			const response = await resetPassword({
				password: values.password,
				token,
			})
			if (response.ok) {
				addToast({
					type: 'success',
					message: `Nové heslo bylo nastaveno.`,
					dismiss: true,
				})
				redirect(redirectOnSuccess)
			} else {
				switch (response.error.code) {
					case 'PASSWORD_TOO_WEAK':
						return addToast({ message: `Heslo je příliš slabé.`, type: 'error', dismiss: true })
					case 'TOKEN_NOT_FOUND':
					case 'TOKEN_USED':
					case 'TOKEN_EXPIRED':
						return addToast({ message: `Odkaz pro nastavení hesla již exspiroval.`, type: 'error', dismiss: true })
				}
			}
		},
		[addToast, redirect, redirectOnSuccess, resetPassword, token],
	),
	)

	return (
		<form onSubmit={onSubmit}>
			<Stack direction="vertical" gap="large">
				<FieldContainer label="Nové heslo">
					<TextInput {...register('password')} required={true} type={'password'} />
				</FieldContainer>
				<FieldContainer label="Nové heslo pro kontrolu">
					<TextInput {...register('passwordAgain')} required={true} type={'password'} />
				</FieldContainer>
				<FieldContainer label={undefined}>
					<Button distinction="primary" type={'submit'} disabled={isSubmitting}>
						Nastavit nové heslo
					</Button>
				</FieldContainer>
			</Stack>
		</form>
	)
}
